import { tabNames } from '@va/constants';
import { requestSettings } from '@va/dashboard/actions/api';
import { setActiveTab } from '@va/dashboard/actions/ui';
import { VisaNestedPageNavigation } from '@va/dashboard/components';
import { PageHeader, TitleAndContextMenu } from '@va/dashboard/shared/ui-layout';
import { FolderIcon, LockIcon, OptOutIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { buildNestedNavigation, buildNestedRoute } from '@va/util/helpers';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PrivacyLevels from './PrivacyLevels';
import LegalDocuments from './legal-documents/LegalDocuments';
import { OptOutLogic } from './opt-out-logic/OptOutLogic';

const PrivacyCenter = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveTab(tabNames.privacyCenter));
    dispatch(requestSettings());
  }, [dispatch]);

  const routes = useMemo(
    () =>
      buildNestedNavigation([
        buildNestedRoute({
          link: '/privacy-levels',
          label: translate('all.privacyCenter.privacyLevel.title'),
          component: PrivacyLevels,
          icon: LockIcon,
          tooltip: 'tooltipTab.privacyLevels',
        }),
        buildNestedRoute({
          link: '/legal-documents',
          label: translate('all.privacyCenter.legalDocuments.title'),
          component: LegalDocuments,
          icon: FolderIcon,
        }),
        buildNestedRoute({
          link: '/opt-out-logic',
          label: translate('all.privacyCenter.optOutLogic.title'),
          component: OptOutLogic,
          icon: OptOutIcon,
        }),
      ]),
    [translate],
  );

  return (
    <>
      <PageHeader
        title={
          <TitleAndContextMenu
            title={translate('all.privacyCenter.tab.title')}
            tooltipTransKey={'tooltipTab.privacyCenter'}
          />
        }
        hideDatePicker
        hideBorder
      />
      <VisaNestedPageNavigation routes={routes} />
    </>
  );
};

export default PrivacyCenter;
